<script>
    import _ from 'lodash'
    import FieldError      from '../../shared/FieldError.svelte'
    import InventoryGroups from './InventoryGroups.svelte'

    export let inventory = null
    export let item      = {}
    export let errors    = {}

    let added = null
    $: groups = computeGroups(inventory, added)

    function computeGroups(inventory, added) {
        let existing = inventory && inventory.placeGroups() || []
        return added ? [...existing, added] : existing
    }

    function cleanse(evt) {
        const trimmed = _.trim(evt.target.value) 
        item.locator = trimmed === '' ? null : trimmed
    }

    function groupChanged(evt) {
        const { add, group } = evt.detail
        if(add) {
            added = { id: 0, text: group }
        }
        item.group = group
    }
</script>

<form class="ui big form">
    <div class="field"
         class:error={errors.name}>
        <label>Nome</label>
        <input  bind:value={item.name}
                type="text"
                autocomplete="false">
        <FieldError style="label" property={errors['name']}/>
    </div>
    <div class="field">
        <InventoryGroups {groups} group={item.group} on:group={groupChanged}></InventoryGroups>
    </div>
    <div class="field"
         class:error={errors.locator}>
        <label>Localizador</label>
        <div class="ui icon input">
            <input type="text" value={item.locator || ''} on:keydown={cleanse}>
            <i class="ui grey question circle outline icon"></i>
        </div>
        <FieldError style="label" property={errors['locator']}/>            
    </div>
    <div class="two fields">
        <div class="field"
             class:error={errors.responsible}>
            <label>Responsável</label>
            <input  bind:value={item.responsible}
                    type="text" 
                    autocomplete="false">
            <FieldError style="label" property={errors['responsible']}/>
        </div>
        <div class="field"
             class:error={errors.email}>
            <label>Email do Responsável</label>
            <input  bind:value={item.email}
                    type="text" 
                    autocomplete="false">
            <FieldError style="label" property={errors['email']}/>
        </div>                        
    </div>
    <div class="field">
        <label>Descrição</label>
        <textarea rows="3" bind:value={item.description}></textarea>
    </div>
</form>
<style>
    .ui.form {
        margin: 2em 0;
        max-width: 90%;
    }

    .ui.form .field {
        margin: 1em 0;
    }    
</style>
